import CommonOperationClass from '../../../commonOperationClass';

const seven = new CommonOperationClass('7');

export default seven;
